/* istanbul ignore file */
import DatePicker from './date-picker';
import CalendarPanel from './calendar/calendar-panel';

Object.assign(DatePicker, {
  CalendarPanel,
});

export default DatePicker;
